import gql from 'graphql-tag'

export const fetchCustomerBasketQuery = gql`
query {
  customerCart {
    id
  }
}
`
